// SitePage_Join Widget
(function (fox) {
	const AutoLoginService = require('../components/auto-login')(fox);
	const emptyValidator = (message) => (value = '') => ({
		result: value.length > 0,
		message
	});
	const getMaxDiscount = require('../components/common/getMaxDiscount')(fox);

	fox.registerWidget('SitePage_Join', {
		configure: function (options) {
			this.registerOptions('', {
				widgets: {
					cbPaymentPopup: {
						widget: 'CBPaymentPopup'
					},
					clientInfo: {
						widget: 'Api',
						method: 'Client_Aboutme.getData',
						cacheChannel: 'site'
					},
					customJoin: {
						optionsBy: 'optionId',
						widget: 'Join_Form',
						container: '#join-form-container',
						template: 'sitepage_join_form',
						'wrapMethods.onSubmit': true,
						'wrapMethods.onPrepareTransaction': true,
						'wrapMethods.prepareTransaction': true,
						'hooks.onStartOnSubmit': this.onStartOnSubmit.bind(this),
						'hooks.onStartOnPrepareTransaction': function () {
							return this.getParent().onPrepareTransaction.apply(this, arguments);
						},
						'hooks.onJoinOptionsPrepare': this.formatData.bind(this),
						'hooks.onStopPrepareTransactionParams': params => {
							const { token } = this.autoLoginService.injectToken(params);

							params.token = token;
						},
						'hooks.onPrepareTransaction': (formData) =>  {
							const joinForm = this.rwom1('#customJoin');
							const method = joinForm.prepareTransactionApi.method();

							if (!fox.isEmpty(fox.getEnv('siteProps.freeJoin')) && method !== 'user.upgrade')
								return joinForm.__wrapped__prepareTransaction(formData);

							this.showCbPopup(new fox.Promise((resolve, reject) => {
								return joinForm.__wrapped__prepareTransaction(formData, resolve, reject);
							}));
						},

						widgets: {
							'errors.container': '#errors.errors',
							form: {
								formContainer: '#join-form',
								submit: {
									target: '#join-form',
									event: 'submit'
								}
							},
							prepareTransactionApi: {
								project: 'modelcloud',
								method: 'user.join',
								httpMethod: 'post'
							},
							joinOptions: {
								container: '.join-options',
								'tpl.row': 'sitepage_join_form_option',
								maxDiscount: getMaxDiscount(),
								handlers: {
									changeOption: {
										'event': 'click',
										target: '.checkbox-handler',
										callback: fox.bind(this.changeOption, this)
									}
								}
							},
							billerOptionsForm: {
								'embed.widget': '@parent @parent',
								'embed.container': '#biller-form-container',
								template: 'sitepage_join_form_billing',
								billerFormSelector: '#biller-form',
								widgets: {
									optionsList: {
										container: '#biller-form',
										tpl: {
											row: 'sitepage_join_form_billing_row'
										}
									}
								}
							}
						},
						'handleWom.onPrepareTransaction.callback': '@parent:onPrepareTransaction'
					}
				},
				'handleWom.joinOptionsPrepared': {
					widget: '#customJoin',
					event: 'joinOptionsPrepared',
					callback: 'formatData',
					params: {
						alwaysActive: true,
						listenHistory: true
					}
				},

				'handleWom.clientInfo': {
					widget: '#clientInfo',
					event: 'success',
					callback: '@this:insertName'
				},

				'handleWom.onPrepareFailed': {
					widget: '#customJoin',
					event: 'onPrepareFailed',
					callback: 'onPrepareFailed'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.autoLoginService = new AutoLoginService(this);

			this.registerOptions('#cbPaymentPopup', {
				matchTokenFunction: token => this.autoLoginService.matchToken(token)
			});

			const path = '#customJoin #form';

			if (fox.isEmpty(this.wom1('@root #permissionManager').getMemberInfo())) {
				const options = {
					email: {
						validators: [
							emptyValidator('email field cannot be empty'),
							{ validator: 'regexp', options: { type: 'email' }, message: 'wrong email format' }
						]
					},
					login: {
						validators: [
							emptyValidator('login field cannot be empty'),
							{validator: 'length', options: { min: 3 }, message: 'login field must be less 3 symbols' },
							{validator: 'regexp', options: {regexp: /^(?!.*[\\\/#"]).*$/i}, message: 'A username cannot contain special characters \ / " #.'}
						]
					},
				}

				if (!fox.getEnv('siteProps.freeJoin')) {
					options.password = {
						validators: [
							emptyValidator('password field cannot be empty'),
							{validator: 'length', options: { min: 6 }, message: 'Sorry, your password must be at least 6 characters long' },
							{validator: 'regexp', options: {regexp: /^(?!.*[\\\/#"]).*$/i}, message: 'A password cannot contain some special characters \ / " #.'}
						]
					};
				}

				this.registerOptions(path, {
					elements: options
				});
			}

			this.callParent('init', arguments);
		},

		running: function () {
			this.rwom1('#clientInfo').send({});
			this.callParent('running', arguments);
		},

		insertName: function (response) {
			var block = fox.dom.selectFirst('#cite-author');
			if (block) {
				block.innerHTML = response.answer.response.success.stats.name;
			}
		},

		changeOption: function (el) {
			var
				chkbx = fox.dom.selectFirst('.chkbx', el),
				current = fox.dom.selectFirst('.checkbox', el),
				group = fox.dom.select('.checkbox', this.element)
			;

			fox.each(group, function (elem) {
				fox.dom.removeClass('checked', elem);
			});

			this.rwom1('#customJoin #form').setValue(chkbx.name, chkbx.value);
			chkbx.checked = true;
			fox.dom.addClass('checked', current);
		},

		formatData: function () {
			var
				listWidget = this.rwom1('#customJoin #joinOptions'),
				optionsList = fox.getEnv('siteProps.ubs.joinOptions.options'),
				defaultOptionExists = false;

			fox.each(optionsList, function (opt) {
				if (opt.type === 'recurring') {
					opt.settings.viewData = (opt.settings.recurringAmount / (opt.settings.recurringPeriod / (opt.settings.recurringPeriodType === 'm' ? 1 : 30))).toFixed(2);
				}

				if (opt['default']) {
					defaultOptionExists = true;
				}

				if (!fox.isEmpty(opt.discountParams)) {
					if (!!opt.settings.viewData) {
						opt.discountParams.discountPrice = (opt.settings.viewData - (opt.settings.viewData * (opt.discountParams.discount / 100))).toFixed(2);
					} else {
						opt.discountParams.discountPrice = (opt.settings.initialAmount - (opt.settings.initialAmount * (opt.discountParams.discount / 100))).toFixed(2);
					}
					if (!!opt.discountParams.discountOptionId) {
						opt.settings.id = opt.id = opt.discountParams.discountOptionId;
					}
				}
			});

			if (!defaultOptionExists && optionsList.length) {
				optionsList[0]['default'] = 1;
			}

			listWidget.setCollection(optionsList);
		},

		onStartOnSubmit: function (userData) {
			var linkerParam = this.rwom1('@root #googleAnalytics').getLinkerParam();
			var formData = {};

			if (linkerParam) {
				formData['transitParams[_ga]'] = linkerParam;
			}

			return true;
		},

		showCbPopup: function (promise) {
			const cbPaymentPopup = this.rwom1('#cbPaymentPopup');

			return promise.then(({ params: { answer: { response: params }}}) => {
				const { submit_url, added_fields } = params;
				const url = `${submit_url}?${fox.toQueryString(added_fields)}`;
				return cbPaymentPopup.show(Promise.resolve({ url }));
			}).catch ((err) => {
				return false 
			});
		},

		onPrepareTransaction: function (data) {
			this.__inProgress = false;
			const _this = this.getParent();
			const form = this.rwom1('#form');
			
			form.enable();

			if (data.freeJoinResult) {
				_this.rwom1('#cbPaymentPopup').hide();
				var layout = fox.site.wom1('#home');
				fox.site.wait(layout, 'addedToDom')
					.then(() => {
						fox.site.wom1('#home #home').activate();
					})
					.catch(console.error);
				fox.site.rwom1('#navi').update({ 0: 'home' }, true);
				fox.site.wom1('#home #home').deactivate();
				const token = _this.autoLoginService.tokens.slice().pop();

				_this.autoLoginService.shouldAuthorize(token).then(result => {
					return result && Object.keys(form.getOption('elements')).filter(field => {
						return field !== 'joinOptions';
					}).forEach(field => {
						form.removeElement(field);
						form.removeOption(`elements.${field}`);
					});
				});
				return false;
			}

			_this.wait('@root #socket', 'inboxSocketEventUser:join:success').then(({params}) => {
				const token = fox.objectGet(params, 'answer.token');

				return _this.autoLoginService.shouldAuthorize(token);
			}).then(result => {
				return result && fox.site.gotoPage('home');
			});

			return false;
		},

		onPrepareFailed: function (err) {
			this.rwom1('#cbPaymentPopup').hide();

			if (err.type === 5) {
				let popup = this.wom1('#errorPopup');

				if (!popup) {
					popup = this.embedWidget('errorPopup', 'Popup_Common', {
						'widgets.content.template': 'upgrade_form_oneclick_error'
					});

					popup.run();
				}

				popup.show();
			}
		}
		
	}, 'Site_Page');
})(fox);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/join.es.js